exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable th[data-v-375f551f],\ntable td[data-v-375f551f] {\n    vertical-align: middle !important;\n    text-align: center !important;\n}\n.hotel-name[data-v-375f551f] {\n    max-width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    text-wrap:  balance;\n    cursor: pointer;\n}\n", ""]);

// exports
